import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { COMPANY } from "@/lib/site";

const NAV = [
  { to: "/", label: "Domů" },
  { to: "/sluzby", label: "Služby" },
  { to: "/o-nas", label: "O nás" },
  { to: "/kontakt", label: "Kontakt" },
  { to: "/klientska-zona", label: "Klientská zóna" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-cream/85 backdrop-blur-md border-b border-line"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <Link to="/" className="flex items-center" data-testid="header-logo">
          <img
            src={COMPANY.logo}
            alt="G&G accounting"
            className="h-10 md:h-12 w-auto object-contain"
            style={{ mixBlendMode: "multiply" }}
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-10" data-testid="primary-nav">
          {NAV.map((n) => {
            const active = pathname === n.to;
            return (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.to.replace(/\//g, "") || "home"}`}
                className={`relative text-sm font-medium tracking-wide transition-colors hover:text-magenta ${
                  active ? "text-ink" : "text-ink/80"
                }`}
              >
                {n.label}
                {active && (
                  <span className="absolute -bottom-2 left-0 right-0 h-[2px] bg-magenta" />
                )}
              </Link>
            );
          })}
        </nav>

        <div className="hidden lg:flex">
          <Link
            to="/sluzby#kalkulacka"
            data-testid="header-cta"
            className="inline-flex items-center bg-magenta hover:bg-magenta-dark text-white text-sm font-medium px-5 py-3 rounded-full transition-colors"
          >
            Nezávazná poptávka
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden inline-flex items-center justify-center w-10 h-10 rounded-md hover:bg-line transition-colors"
          aria-label={open ? "Zavřít menu" : "Otevřít menu"}
          onClick={() => setOpen((s) => !s)}
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-line bg-cream" data-testid="mobile-menu">
          <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-4">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`mobile-nav-${n.to.replace(/\//g, "") || "home"}`}
                className="text-base font-medium text-ink hover:text-magenta py-2"
              >
                {n.label}
              </Link>
            ))}
            <Link
              to="/sluzby#kalkulacka"
              data-testid="mobile-header-cta"
              className="mt-2 inline-flex items-center justify-center bg-magenta text-white px-5 py-3 rounded-full font-medium"
            >
              Nezávazná poptávka
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
